import { TeamTab } from "@/features/team/components/team-tab";

/** Standalone Team page (sidebar / header account menu). The header, summary
 * band, roster, inline editor and role hierarchy all render from TeamTab, which
 * needs the live member list for its counts and grouping. */
export default function TeamPage() {
  return <TeamTab />;
}
